module.exports = __webpack_public_path__ + "static/media/tick-success-basic.74b62a67.svg";